import { useQuery } from '@tanstack/react-query'

import i18n from './i18n'
import css from './index.module.css'

import { AddToCartEshop } from '#/global/component/Product/AddToCart/Eshop'
import { ProductPreviewCompact } from '#/global/component/Product/ProductPreviewCompact'

import { ServiceProduct } from '#/global/service/Product'

import { Config } from '#/global/helper/Config'
import { showProductDetail } from '#/global/helper/DataLayer/modalCrossSelling'

interface Props {
    productCodeList: string[]
}

export const ProductList = ({ productCodeList }: Props) => {
    const productList = useQuery({
        queryKey: ['EshopRelatedItems', productCodeList],
        queryFn: async () => ServiceProduct.getProductEshopByCode(productCodeList, ['detail', 'price', 'availability', 'unit']),
    })

    const lang = Config.getLang()

    const t = i18n[lang]

    return (
        <div className={css.container}>
            <h4>{t.title}</h4>
            <div className={css.content}>
                {productList.isSuccess && productList.data !== undefined && productList.data.map(product => product && (
                    <ProductPreviewCompact
                        key={product.code}
                        lang={lang}
                        onTitleClick={() => showProductDetail(product.code)}
                        product={product}
                        AddToCart={(
                            <AddToCartEshop
                                lang={lang}
                                product={product}
                                type="compact"
                            />
                        )}
                    />
                ))}
                {(!productList.isSuccess || productList.data === undefined) && Array.from({ length: productCodeList.length }).map((_, index) => (
                    <ProductPreviewCompact key={index} loadingState />
                ))}
            </div>
        </div>
    )
}
